export default __webpack_public_path__ + "static/media/import-points-example-fi.ce0c51dc.xlsx";